import { Typography } from "@material-ui/core";
export function enoxaparinText(renalImpairmentLevel, overWeightLimit) {
    let text = [];
    text.push([<Typography variant="body1" style={{ marginTop: 20 }}>
                    <strong>ENOXAPARIN</strong>
                </Typography>,
                <Typography variant="body2">
                    <p>Enoxaparin treatment dose based upon consultant advice.</p>
                    <p>
                    If enoxaparin is selected, discuss with consultant prior to
                    prescribing.
                    </p>
                    {(renalImpairmentLevel == 'severe') ? <p>
                                        <strong>
                                          Documented consultant approval is required for therapeutic
                                          enoxaparin use in patients if CrCl less than 30mL/min.
                                        </strong>
                                      </p> : (overWeightLimit) ? <p>
                                        <strong>
                                          Documented consultant approval is required for therapeutic
                                          enoxaparin use if patient weight is more than 120kg.
                                        </strong>
                                      </p> : ''}
                    
                    <p>
                    Note: Enoxaparin dose-capping may limit supratherapeutic levels but
                    may result in under-dosing. Weight based enoxaparin dosing using
                    actual body weight may result in over-dose and bleeding. Ensure
                    monitoring if enoxaparin is used.
                    </p>
                </Typography>,
                ]);
    
    return text;
}